<div class="banner d-flex align-items-center justify-content-center">
  <span class="banner-text">
    <i class="fa fa-server"></i>
    Test Server
  </span>
</div>
